import useUpdateDropTaskSubmissions from '../../../../hooks/useUpdateDropTaskSubmissions'
import SharedGraphIndexerTask, {
  Props,
} from '../../../../shared_components/Missions/Types/GraphIndexer'
import TaskAllocationAmount from '../../../../shared_components/Missions/TaskAllocationAmount'

export default function GraphIndexerTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount'>,
) {
  const updateTaskSubmissions = useUpdateDropTaskSubmissions()
  return (
    <SharedGraphIndexerTask
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      taskAmount={<TaskAllocationAmount taskId={props.taskId} rewardDisplay='XP' />}
    />
  )
}
